import { render, staticRenderFns } from "./UserTerminalStock.vue?vue&type=template&id=878708f4&"
import script from "./UserTerminalStock.vue?vue&type=script&lang=js&"
export * from "./UserTerminalStock.vue?vue&type=script&lang=js&"
import style0 from "./UserTerminalStock.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports